  // import React, { useState, useEffect } from "react";
  // import {
  //   Box,
  //   Card,
  //   CardContent,
  //   Typography,
  //   Avatar,
  //   IconButton,
  //   Container,
  //   Skeleton,
  //   Chip,
  //   Zoom,
  //   useTheme,
  //   useMediaQuery,
  //   ThemeProvider,
  //   createTheme,
  //   CssBaseline,
  //   LinearProgress,
  //   Alert,
  //   Dialog,
  //   DialogTitle,
  //   DialogContent,
  //   DialogActions,
  //   Select,
  //   MenuItem,
  //   FormControl,
  //   InputLabel,
  //   Stack,
  //   Tooltip,
  //   Button, // ADDED THIS IMPORT
  // } from "@mui/material";
  // import {
  //   Dashboard as DashboardIcon,
  //   Description as DocumentIcon,
  //   PendingActions as PendingIcon,
  //   Chat as ChatIcon,
  //   Notifications as NotificationIcon,
  //   Settings as SettingsIcon,
  //   Assessment as AssessmentIcon,
  //   Timeline as TimelineIcon,
  //   BarChart as BarChartIcon,
  //   Refresh as RefreshIcon,
  //   Close as CloseIcon,
  // } from "@mui/icons-material";
  // import DashboardServices from "../services/dashboardServices";
  // import { toast, ToastContainer } from "react-toastify";
  // import Loader from "../utils/loader";
  // import { useSelector } from "react-redux";
  // import { Link } from "react-router-dom";
  // import { getnotifications } from "../services/notficationService";
  // import StatusApexChartsComp from "./ReusableComponents/StatusApexChartsComp";
  // import documentService from "../services/document";
  // import moment from "moment/moment";
  // import Grid2 from "@mui/material/Unstable_Grid2";

  // // Enhanced Material-UI Theme
  // const createCustomTheme = (isDarkMode) =>
  //   createTheme({
  //     palette: {
  //       mode: isDarkMode ? "dark" : "light",
  //       primary: {
  //         main: "#1976d2",
  //         light: "#42a5f5",
  //         dark: "#1565c0",
  //       },
  //       secondary: {
  //         main: "#9c27b0",
  //         light: "#ba68c8",
  //         dark: "#7b1fa2",
  //       },
  //       success: {
  //         main: "#2e7d32",
  //         light: "#4caf50",
  //         dark: "#1b5e20",
  //       },
  //       warning: {
  //         main: "#ed6c02",
  //         light: "#ff9800",
  //         dark: "#e65100",
  //       },
  //       error: {
  //         main: "#d32f2f",
  //         light: "#f44336",
  //         dark: "#c62828",
  //       },
  //       background: {
  //         default: isDarkMode ? "#0a0e1a" : "#f8fafc",
  //         paper: isDarkMode ? "#1a1f2e" : "#ffffff",
  //       },
  //       text: {
  //         primary: isDarkMode ? "#ffffff" : "#1a202c",
  //         secondary: isDarkMode ? "#a0aec0" : "#4a5568",
  //       },
  //     },
  //     typography: {
  //       fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  //       h4: {
  //         fontWeight: 700,
  //         fontSize: "2.25rem",
  //         letterSpacing: "-0.025em",
  //       },
  //       h5: {
  //         fontWeight: 600,
  //         fontSize: "1.75rem",
  //         letterSpacing: "-0.025em",
  //       },
  //       h6: {
  //         fontWeight: 600,
  //         fontSize: "1.25rem",
  //         letterSpacing: "-0.025em",
  //       },
  //       subtitle1: {
  //         fontWeight: 500,
  //         fontSize: "1rem",
  //         lineHeight: 1.5,
  //       },
  //       body1: {
  //         fontSize: "0.875rem",
  //         lineHeight: 1.6,
  //       },
  //     },
  //     shape: {
  //       borderRadius: 16,
  //     },
  //     components: {
  //       MuiCard: {
  //         styleOverrides: {
  //           root: {
  //             boxShadow: isDarkMode
  //               ? "0 10px 40px rgba(0,0,0,0.4), 0 2px 8px rgba(0,0,0,0.2)"
  //               : "0 10px 40px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)",
  //             borderRadius: 20,
  //             transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  //             border: isDarkMode
  //               ? "1px solid rgba(255,255,255,0.1)"
  //               : "1px solid rgba(0,0,0,0.05)",
  //             background: isDarkMode
  //               ? "linear-gradient(135deg, rgba(255,255,255,0.02) 0%, rgba(255,255,255,0.05) 100%)"
  //               : "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.95) 100%)",
  //             backdropFilter: "blur(20px)",
  //             "&:hover": {
  //               transform: "translateY(-8px) scale(1.02)",
  //               boxShadow: isDarkMode
  //                 ? "0 20px 60px rgba(0,0,0,0.5), 0 8px 16px rgba(0,0,0,0.3)"
  //                 : "0 20px 60px rgba(0,0,0,0.12), 0 8px 16px rgba(0,0,0,0.08)",
  //             },
  //           },
  //         },
  //       },
  //       MuiButton: {
  //         styleOverrides: {
  //           root: {
  //             borderRadius: 12,
  //             textTransform: "none",
  //             fontWeight: 600,
  //             padding: "10px 24px",
  //             boxShadow: "none",
  //             "&:hover": {
  //               boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
  //               transform: "translateY(-2px)",
  //             },
  //           },
  //         },
  //       },
  //       MuiPaper: {
  //         styleOverrides: {
  //           root: {
  //             backgroundImage: "none",
  //           },
  //         },
  //       },
  //     },
  //   });

  // // Enhanced Stat Card Component
  // const StatCard = ({ title, value, icon, color, trend, isLoading, onClick }) => {
  //   const theme = useTheme();

  //   return (
  //     <Zoom in={!isLoading} style={{ transitionDelay: "100ms" }}>
  //       <Card
  //         sx={{
  //           height: "100%",
  //           cursor: onClick ? "pointer" : "default",
  //           background: `linear-gradient(135deg, ${color}15 0%, ${color}08 50%, ${color}03 100%)`,
  //           border: `2px solid ${color}20`,
  //           position: "relative",
  //           overflow: "hidden",
  //           "&:hover": onClick
  //             ? {
  //                 transform: "translateY(-8px) scale(1.02)",
  //                 boxShadow: `0 20px 40px ${color}25`,
  //                 border: `2px solid ${color}40`,
  //               }
  //             : {},
  //           "&::before": {
  //             content: '""',
  //             position: "absolute",
  //             top: -50,
  //             right: -50,
  //             width: "150px",
  //             height: "150px",
  //             background: `radial-gradient(circle, ${color}20 0%, transparent 70%)`,
  //             borderRadius: "50%",
  //           },
  //           "&::after": {
  //             content: '""',
  //             position: "absolute",
  //             bottom: -30,
  //             left: -30,
  //             width: "100px",
  //             height: "100px",
  //             background: `linear-gradient(45deg, ${color}10, transparent)`,
  //             borderRadius: "50%",
  //           },
  //         }}
  //         onClick={onClick}
  //       >
  //         <CardContent sx={{ position: "relative", zIndex: 1, p: 3 }}>
  //           <Box
  //             sx={{
  //               display: "flex",
  //               alignItems: "center",
  //               justifyContent: "space-between",
  //               mb: 3,
  //             }}
  //           >
  //             <Avatar
  //               sx={{
  //                 bgcolor: `${color}25`,
  //                 color: color,
  //                 width: 64,
  //                 height: 64,
  //                 boxShadow: `0 8px 20px ${color}30`,
  //               }}
  //             >
  //               {icon}
  //             </Avatar>
  //             {trend && (
  //               <Chip
  //                 label={trend}
  //                 size="small"
  //                 sx={{
  //                   bgcolor: trend.includes("+")
  //                     ? theme.palette.success.main
  //                     : theme.palette.error.main,
  //                   color: "white",
  //                   fontWeight: 700,
  //                   boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  //                 }}
  //               />
  //             )}
  //           </Box>

  //           {isLoading ? (
  //             <Box>
  //               <Skeleton variant="text" width="60%" height={36} />
  //               <Skeleton variant="text" width="40%" height={28} />
  //             </Box>
  //           ) : (
  //             <Box>
  //               <Typography
  //                 variant="h4"
  //                 component="div"
  //                 sx={{
  //                   fontWeight: 800,
  //                   color: color,
  //                   mb: 1,
  //                   textShadow: `0 2px 4px ${color}20`,
  //                 }}
  //               >
  //                 {value}
  //               </Typography>
  //               <Typography
  //                 variant="subtitle1"
  //                 color="text.Primary"
  //                 sx={{ fontWeight: 600, opacity: 0.8 }}
  //               >
  //                 {title}
  //               </Typography>
  //             </Box>
  //           )}
  //         </CardContent>
  //       </Card>
  //     </Zoom>
  //   );
  // };

  // // Enhanced Chart Container Component
  // const ChartContainer = ({
  //   title,
  //   children,
  //   actions,
  //   isLoading,
  //   height = 400,
  //   icon,
  //   gradientColors,
  // }) => {
  //   const theme = useTheme();

  //   return (
  //     <Card
  //       sx={{
  //         height: "100%",
  //         display: "flex",
  //         flexDirection: "column",
  //         background: gradientColors
  //           ? `linear-gradient(135deg, ${gradientColors[0]}08 0%, ${gradientColors[1]}05 50%, ${gradientColors[0]}03 100%)`
  //           : undefined,
  //         border: gradientColors ? `1px solid ${gradientColors[0]}20` : undefined,
  //       }}
  //     >
  //       <CardContent
  //         sx={{ flexGrow: 1, display: "flex", flexDirection: "column", p: 3 }}
  //       >
  //         <Box
  //           sx={{
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "space-between",
  //             mb: 3,
  //             pb: 2,
  //             borderBottom: `1px solid ${theme.palette.divider}`,
  //           }}
  //         >
  //           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
  //             {icon && (
  //               <Avatar
  //                 sx={{
  //                   bgcolor: gradientColors
  //                     ? `${gradientColors[0]}20`
  //                     : "primary.light",
  //                   color: gradientColors ? gradientColors[0] : "primary.main",
  //                   width: 48,
  //                   height: 48,
  //                 }}
  //               >
  //                 {icon}
  //               </Avatar>
  //             )}
  //             <Typography
  //               variant="h6"
  //               component="h2"
  //               sx={{
  //                 fontWeight: 700,
  //                 color: gradientColors ? gradientColors[0] : "text.primary",
  //                 textShadow: gradientColors
  //                   ? `0 1px 2px ${gradientColors[0]}20`
  //                   : undefined,
  //               }}
  //             >
  //               {title}
  //             </Typography>
  //           </Box>
  //           {actions && (
  //             <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
  //               {actions}
  //             </Box>
  //           )}
  //         </Box>

  //         {isLoading ? (
  //           <Box
  //             sx={{
  //               flexGrow: 1,
  //               display: "flex",
  //               flexDirection: "column",
  //               justifyContent: "center",
  //             }}
  //           >
  //             <Skeleton
  //               variant="rectangular"
  //               height={height - 120}
  //               sx={{ borderRadius: 2 }}
  //             />
  //           </Box>
  //         ) : (
  //           <Box
  //             sx={{
  //               flexGrow: 1,
  //               display: "flex",
  //               flexDirection: "column",
  //               minHeight: height - 120,
  //             }}
  //           >
  //             {children}
  //           </Box>
  //         )}
  //       </CardContent>
  //     </Card>
  //   );
  // };

  // const DashboardPage = () => {
  //   const [loading, setLoading] = useState(false);
  //   const [selectYear, setSelectYear] = useState(new Date().getFullYear());
  //   const [selectMonth, setSelectMonth] = useState(new Date().getMonth() + 1);

  //   // FIXED: Updated years array to include current year (2026)
  //   const [years, setYears] = useState(() => {
  //     const currentYear = new Date().getFullYear();
  //     // Start from 2019 to current year (inclusive)
  //     const yearsArray = [];
  //     for (let year = 2019; year <= currentYear; year++) {
  //       yearsArray.push(year);
  //     }
  //     return yearsArray;
  //   });

  //   const [selected, setSelected] = useState(new Date().getFullYear());
  //   const [totalMyDocs, setTotalMyDocs] = useState(0);
  //   const [totalSharedDocs, setTotalSharedDocs] = useState(0);
  //   const [imageCardData, setImageCardData] = useState({
  //     totalDocuments: "0",
  //     pendingForApproval: "0",
  //     unreadMsgCount: "0",
  //   });
  //   const userDetails = useSelector((state) => state.user);
  //   const isGuest = localStorage.getItem("is_guest");

  //   const userID = userDetails?.currentUser?._id;

  //   const userRole = sessionStorage.getItem("Role");
  //   const [yearList, setYearList] = useState(() => {
  //     const currentYear = new Date().getFullYear();
  //     const yearsArray = [];
  //     for (let year = 2019; year <= currentYear; year++) {
  //       yearsArray.push({ name: year.toString(), value: year });
  //     }
  //     return yearsArray;
  //   });
  //   const [teamList, setTeamList] = useState([]);
  //   const [barChartYear, setBarChartYear] = useState(new Date().getFullYear());
  //   const [statusChartYear, setStatusChartYear] = useState(
  //     new Date().getFullYear(),
  //   );
  //   const [selectedMember, setSelectedMember] = useState();
  //   const [isBarChartDropdown, setIsBarChartDropdown] = useState(false);
  //   const [isPieChartDropdown, setIsPieChartDropdown] = useState(false);
  //   const [barChartData, setBarChartData] = useState({
  //     bar1Count: 0,
  //     bar2Count: 0,
  //     chartHeading: "Documents & Reviews",
  //     bar1Name: `Documents(0)`,
  //     bar2Name: `Reviews(0)`,
  //     xAxis: [
  //       "Jan",
  //       "Feb",
  //       "Mar",
  //       "Apr",
  //       "May",
  //       "June",
  //       "July",
  //       "Aug",
  //       "Sept",
  //       "Oct",
  //       "Nov",
  //       "Dec",
  //     ],
  //     bar1Datas: [],
  //     bar2Data: [],
  //   });
  //   const [barDocsStatusChartData, setBarDocsStatusChartData] = useState({
  //     chartHeading: "Documents & Reviews Status",
  //     bar1Name: "Documents",
  //     bar2Name: "Reviews",
  //     xAxis: ["Pending", "Progress", "Completed", "Rejected", "Published"],
  //     counts: [],
  //   });
  //   const [notifications, setNotifications] = useState([]);
  //   const [isDarkMode, setIsDarkMode] = useState(false);
  //   const screenData = useSelector(
  //     (state) => state.manageSubscriptionPlan.subscriptionPlan,
  //   );
  //   const [alertForEndSub, setAlertForEndSub] = useState("");
  //   const [showPopup, setShowPopup] = useState(false);

  //   const theme = createCustomTheme(isDarkMode);
  //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  //   const isTablet = useMediaQuery(theme.breakpoints.down("lg"));

  //   // ✅ Guest demo data
  //   useEffect(() => {
  //     if (isGuest) {
  //       setTotalMyDocs(12);
  //       setTotalSharedDocs(4);

  //       setImageCardData({
  //         totalDocuments: "16",
  //         pendingForApproval: "3",
  //         unreadMsgCount: "5",
  //       });

  //       setBarChartData((prev) => ({
  //         ...prev,
  //         bar1Datas: [2, 3, 4, 5, 6, 4, 3, 2, 1, 3, 5, 4],
  //         bar2Data: [1, 2, 1, 2, 3, 2, 1, 1, 2, 2, 3, 2],
  //         bar1Count: 42,
  //         bar2Count: 22,
  //         bar1Name: "Documents(42)",
  //         bar2Name: "Reviews(22)",
  //       }));

  //       setBarDocsStatusChartData((prev) => ({
  //         ...prev,
  //         counts: [3, 5, 8, 2, 6],
  //       }));
  //     }
  //   }, [isGuest]);

  //   useEffect(() => {
  //     const alertShown = sessionStorage.getItem("subscriptionAlertShown");
  //     const roleOfUser = sessionStorage.getItem("Role");

  //     const checkSubscriptionExpiry = () => {
  //       if (
  //         !alertShown &&
  //         screenData?.isDefault == false &&
  //         roleOfUser == "Individual"
  //       ) {
  //         const now = moment().startOf("day");
  //         const expiryDate = moment(screenData?.endDate).startOf("day");
  //         const daysLeft = expiryDate.diff(now, "days");

  //         if (daysLeft >= 1 && daysLeft <= 5) {
  //           setAlertForEndSub(
  //             `Your subscription will expire in ${daysLeft} day(s) on ${expiryDate.format(
  //               "D MMMM YYYY",
  //             )}.`,
  //           );
  //           setShowPopup(true);
  //         } else if (daysLeft === 0) {
  //           setAlertForEndSub(
  //             `Your subscription expires today on ${expiryDate.format(
  //               "D MMMM YYYY",
  //             )}.`,
  //           );
  //           setShowPopup(true);
  //         } else {
  //           setAlertForEndSub("");
  //         }
  //         if ((daysLeft >= 1 && daysLeft <= 5) || daysLeft === 0) {
  //           sessionStorage.setItem("subscriptionAlertShown", "true");
  //         }
  //       }
  //     };

  //     checkSubscriptionExpiry();
  //   }, [screenData?.endDate]);

  //   const handleClose = () => {
  //     setShowPopup(false);
  //   };

  //   useEffect(() => {
  //     const updateTheme = () => {
  //       const theme = localStorage.getItem("ThemeSwitch");
  //       setIsDarkMode(theme === "true");
  //     };
  //     updateTheme();
  //     window.addEventListener("storage", updateTheme);
  //     const originalSetItem = localStorage.setItem;
  //     localStorage.setItem = function (key, value) {
  //       originalSetItem.apply(this, arguments);
  //       if (key === "ThemeSwitch") {
  //         updateTheme();
  //       }
  //     };
  //     return () => {
  //       window.removeEventListener("storage", updateTheme);
  //       localStorage.setItem = originalSetItem;
  //     };
  //   }, []);

  //   const { leftNavbarOpen } = useSelector(
  //     (state) => state.handleModelAndSideBavBar,
  //   );

  //   // Initialize year list dynamically
  //   useEffect(() => {
  //     const currentYear = new Date().getFullYear();
  //     const yearsArray = [];
  //     for (let year = 2019; year <= currentYear; year++) {
  //       yearsArray.push({ name: year.toString(), value: year });
  //     }
  //     setYearList(yearsArray);
  //     setYears(yearsArray.map((y) => y.value));
  //     setIsBarChartDropdown(true);
  //   }, []);

  //   // useEffect(() => {
  //   //   fetchYearList();
  //   //   getUserDashCardDetails();
  //   //   getUserBarChartDetails(barChartYear);
  //   // }, []);

  //   useEffect(() => {
  //     if (!isGuest) {
  //       fetchYearList();
  //       getUserDashCardDetails();
  //       getUserBarChartDetails(barChartYear);
  //     }
  //   }, [isGuest]);

  //   const fetchYearList = async () => {
  //     setLoading(true);
  //     try {
  //       let response = await DashboardServices.getYearList();
  //       console.log("fetchYearList", response);
  //       if (response.status == 200) {
  //         // Ensure current year is included
  //         const currentYear = new Date().getFullYear();
  //         const serverYears = response.yearList || [];

  //         // Check if current year is in the list
  //         if (!serverYears.includes(currentYear)) {
  //           serverYears.push(currentYear);
  //           serverYears.sort((a, b) => a - b);
  //         }

  //         let finalArr = serverYears.map((year) => ({
  //           name: year.toString(),
  //           value: year,
  //         }));
  //         setYearList(finalArr);
  //         setYears(serverYears);
  //         setIsBarChartDropdown(true);
  //       }
  //     } catch (error) {
  //       console.log("error", error);
  //       // Fallback: create years array manually
  //       const currentYear = new Date().getFullYear();
  //       const yearsArray = [];
  //       for (let year = 2019; year <= currentYear; year++) {
  //         yearsArray.push(year);
  //       }
  //       const finalArr = yearsArray.map((year) => ({
  //         name: year.toString(),
  //         value: year,
  //       }));
  //       setYearList(finalArr);
  //       setYears(yearsArray);
  //       setIsBarChartDropdown(true);
  //     }
  //     setLoading(false);
  //   };

  //   const fetchTeamList = async () => {
  //     setLoading(true);
  //     try {
  //       let response = await DashboardServices.getTeamMembersDetails(userID);
  //       console.log("fetchTeamList", response);
  //       let finalArr = [];
  //       response.memberNames.map((obj) =>
  //         finalArr.push({ name: obj.name, value: obj.id }),
  //       );
  //       setTeamList(finalArr);
  //       setIsPieChartDropdown(true);
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //     setLoading(false);
  //   };

  //   const getDocs = async () => {
  //     try {
  //       const response = await documentService.getAllMyDocuments();
  //       if (response.status === 200) {
  //         setTotalMyDocs(response.data.length);
  //       } else {
  //         console.error("Error fetching data:", response.message);
  //       }
  //     } catch (error) {
  //       console.error("Error calling backend API:", error.message);
  //     }
  //   };

  //   const getSharedDocs = async () => {
  //     try {
  //       const response = await documentService.getSharedDocuments();
  //       if (response.status === 200) {
  //         setTotalSharedDocs(response.data.length);
  //       } else {
  //         console.error("Error fetching data:", response.message);
  //       }
  //     } catch (error) {
  //       console.error("Error calling backend API:", error.message);
  //     }
  //   };

  //   // useEffect(() => {
  //   //   getDocs();
  //   //   getSharedDocs();
  //   // }, []);
  //   useEffect(() => {
  //     if (!isGuest) {
  //       getDocs();
  //       getSharedDocs();
  //     }
  //   }, [isGuest]);

  //   const getUserDashCardDetails = async () => {
  //     setLoading(true);
  //     try {
  //       let response = await DashboardServices.getIndividualDashCards(userID);
  //       console.log("getUserDashCardDetails", response);
  //       let { totalDocuments, pendingForApproval, unreadMsgCount } = response;
  //       setImageCardData({
  //         totalDocuments: totalDocuments,
  //         pendingForApproval: pendingForApproval,
  //         unreadMsgCount: unreadMsgCount,
  //       });
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //     setLoading(false);
  //   };

  //   const getUserBarChartDetails = async (year) => {
  //     setLoading(true);
  //     try {
  //       let response = await DashboardServices.getIndividualBarChart(
  //         userID,
  //         year,
  //       );
  //       console.log("getUserBarChartDetails", response);
  //       let { bar1, bar2, bar1Count, bar2Count } = response;
  //       setBarChartData((prevState) => ({
  //         ...prevState,
  //         bar1Datas: bar1,
  //         bar2Data: bar2,
  //         bar1Count: bar1Count,
  //         bar2Count: bar2Count,
  //         bar1Name: `Documents(${bar1Count})`,
  //         bar2Name: `Reviews(${bar2Count})`,
  //       }));
  //       let isBar1 = bar1.some((obj) => obj > 0);
  //       let isBar2 = bar2.some((obj) => obj > 0);
  //       if (!isBar1 && !isBar2) {
  //         // toast.warn("No records were found")
  //       }
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //     setLoading(false);
  //   };

  //   const handleFetchStatus = async (year = statusChartYear) => {
  //     try {
  //       let response = await DashboardServices.getDocsStatusBarChart(
  //         userID,
  //         year,
  //       );
  //       console.log("statusdata", response);
  //       let bar1 = response.counts;
  //       console.log("bar1:", bar1);
  //       setBarDocsStatusChartData({ ...barDocsStatusChartData, counts: bar1 });
  //       console.log("bar1status2", bar1);
  //       let isBar1 = bar1.some((obj) => obj > 0);
  //       if (!isBar1) {
  //         // toast.warn("No records were found")
  //       }
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //   };

  //   // useEffect(() => {
  //   //   handleFetchStatus();
  //   // }, []);
  //   useEffect(() => {
  //     if (!isGuest) {
  //       handleFetchStatus();
  //     }
  //   }, [isGuest]);

  //   const handleBarChartYear = (year) => {
  //     console.log("handleBarChartYear", year);
  //     let currentYear = new Date().getFullYear();
  //     if (year > currentYear) {
  //       toast.warn("Please enter current or past year");
  //       return;
  //     }
  //     getUserBarChartDetails(year);
  //   };

  //   const handleStatusChartYear = (year) => {
  //     console.log("handleStatusChartYear", year);
  //     let currentYear = new Date().getFullYear();
  //     if (year > currentYear) {
  //       toast.warn("Please enter current or past year");
  //       return;
  //     }
  //     setStatusChartYear(year);
  //     handleFetchStatus(year);
  //   };

  //   const getNotifications = async () => {
  //     try {
  //       let notifications = await getnotifications();
  //       console.log("notifications", notifications);
  //       setNotifications(notifications || []);
  //     } catch (error) {
  //       console.error("Error fetching notifications:", error);
  //       setNotifications([]);
  //     }
  //   };

  //   // useEffect(() => {
  //   //   getNotifications();
  //   // }, []);

  //   // Stats data for the cards

  //   useEffect(() => {
  //     if (!isGuest) {
  //       getNotifications();
  //     }
  //   }, [isGuest]);

  //   const statsData = [
  //     {
  //       title: "Total Documents",
  //       value: (totalMyDocs + totalSharedDocs).toString() || "0",
  //       icon: <DocumentIcon />,
  //       color: theme.palette.primary.main,
  //       link: "/mydocuments",
  //     },
  //     {
  //       title: "Pending Approval",
  //       value: imageCardData.pendingForApproval || "0",
  //       icon: <PendingIcon />,
  //       color: theme.palette.warning.main,
  //       link: "/mydocuments",
  //     },
  //     {
  //       title: "Organization Chats",
  //       value: imageCardData.unreadMsgCount || "0",
  //       icon: <ChatIcon />,
  //       color: theme.palette.success.main,
  //       link: "/chat",
  //     },
  //   ];
  //   const shouldWaitForUser = !isGuest && !userID;

  //   return shouldWaitForUser ? (
  //     <Loader loading={true} />
  //   ) : (
  //     <ThemeProvider theme={theme}>
  //       <CssBaseline />
  //       <Box
  //         sx={{
  //           flexGrow: 1,
  //           bgcolor: "background.default",
  //           minHeight: "100vh",
  //           p: { xs: 2, md: 4 },
  //           background: isDarkMode
  //             ? "radial-gradient(ellipse at top, #1a1f2e 0%, #0a0e1a 100%)"
  //             : "radial-gradient(ellipse at top, #f8fafc 0%, #e2e8f0 100%)",
  //         }}
  //       >
  //         <ToastContainer />
  //         <Loader loading={loading} />

  //         {/* Enhanced Header Section */}
  //         <Box sx={{ mb: 5 }}>
  //           <Typography
  //             variant="h4"
  //             component="h1"
  //             sx={{
  //               fontWeight: 800,
  //               color: "primary.main",
  //               mb: 1,
  //             }}
  //           >
  //             Dashboard Analytics
  //           </Typography>
  //           <Typography
  //             variant="subtitle1"
  //             color="text.primary"
  //             sx={{
  //               fontWeight: 500,
  //               opacity: 0.8,
  //             }}
  //           >
  //             Welcome back! Here's what's happening with your documents today.
  //           </Typography>
  //         </Box>

  //         {/* Stats Cards Section */}
  //         <Grid2 container spacing={4} sx={{ mb: 5 }}>
  //           {statsData.map((stat, index) => (
  //             <Grid2 item xs={12} sm={6} md={4} key={index}>
  //               <Link to={stat.link} style={{ textDecoration: "none" }}>
  //                 <StatCard
  //                   title={stat.title}
  //                   value={stat.value}
  //                   icon={stat.icon}
  //                   color={stat.color}
  //                   trend={stat.trend}
  //                   isLoading={loading}
  //                   onClick={() => {}}
  //                 />
  //               </Link>
  //             </Grid2>
  //           ))}
  //         </Grid2>

  //         {/* Enhanced Side-by-Side Charts Section */}
  //         <Grid2 container spacing={4} sx={{ mb: 5 }}>
  //           {/* Documents & Reviews Status Chart */}
  //           <Grid2 item xs={12} lg={5}>
  //             <ChartContainer
  //               title="Documents & Reviews Status"
  //               isLoading={loading}
  //               height={320}
  //               icon={<AssessmentIcon />}
  //               gradientColors={[
  //                 theme.palette.warning.main,
  //                 theme.palette.warning.light,
  //               ]}
  //               actions={
  //                 isBarChartDropdown && (
  //                   <Stack direction="row" spacing={1} alignItems="center">
  //                     <Chip
  //                       label="Status"
  //                       size="small"
  //                       sx={{
  //                         bgcolor: theme.palette.warning.light + "20",
  //                         color: theme.palette.warning.main,
  //                         fontWeight: 600,
  //                         border: `1px solid ${theme.palette.warning.main}30`,
  //                         fontSize: "0.75rem",
  //                       }}
  //                     />
  //                     <FormControl size="small" sx={{ minWidth: 100 }}>
  //                       <InputLabel>Year</InputLabel>
  //                       <Select
  //                         value={statusChartYear}
  //                         label="Year"
  //                         onChange={(e) => {
  //                           handleStatusChartYear(e.target.value);
  //                         }}
  //                         sx={{
  //                           borderRadius: 2,
  //                           fontSize: "0.875rem",
  //                           "& .MuiOutlinedInput-notchedOutline": {
  //                             borderColor: theme.palette.warning.main + "30",
  //                           },
  //                           "&:hover .MuiOutlinedInput-notchedOutline": {
  //                             borderColor: theme.palette.warning.main + "60",
  //                           },
  //                         }}
  //                       >
  //                         {yearList.map((year) => (
  //                           <MenuItem key={year.value} value={year.value}>
  //                             {year.name}
  //                           </MenuItem>
  //                         ))}
  //                       </Select>
  //                     </FormControl>
  //                   </Stack>
  //                 )
  //               }
  //             >
  //               <StatusApexChartsComp
  //                 chartHeading=""
  //                 cmp1={barChartData.bar1Name}
  //                 cmp2={barChartData.bar2Name}
  //                 bar1={barDocsStatusChartData.counts}
  //                 xAxisList={barDocsStatusChartData.xAxis}
  //                 isSelectDropdownShown={false}
  //                 barChartSelectOptions={yearList}
  //                 barChartValue={statusChartYear}
  //                 barChartSelectLabel="Year"
  //                 isDarkMode={isDarkMode}
  //               />
  //             </ChartContainer>
  //           </Grid2>

  //           {/* Documents & Reviews Analytics Chart */}
  //           <Grid2 item xs={12} lg={7}>
  //             <ChartContainer
  //               title="Documents & Reviews Analytics"
  //               isLoading={loading}
  //               height={320}
  //               icon={<TimelineIcon />}
  //               gradientColors={[
  //                 theme.palette.primary.main,
  //                 theme.palette.primary.light,
  //               ]}
  //               actions={
  //                 <Stack direction="row" spacing={2} alignItems="center">
  //                   <Chip
  //                     label={`Documents: ${barChartData.bar1Count}`}
  //                     size="small"
  //                     sx={{
  //                       bgcolor: theme.palette.primary.light + "20",
  //                       color: theme.palette.primary.main,
  //                       fontWeight: 600,
  //                       border: `1px solid ${theme.palette.primary.main}30`,
  //                     }}
  //                   />
  //                   <Chip
  //                     label={`Reviews: ${barChartData.bar2Count}`}
  //                     size="small"
  //                     sx={{
  //                       bgcolor: theme.palette.secondary.light + "20",
  //                       color: theme.palette.secondary.main,
  //                       fontWeight: 600,
  //                       border: `1px solid ${theme.palette.secondary.main}30`,
  //                     }}
  //                   />
  //                   {isBarChartDropdown && (
  //                     <FormControl size="small" sx={{ minWidth: 120 }}>
  //                       <InputLabel>Year</InputLabel>
  //                       <Select
  //                         value={barChartYear}
  //                         label="Year"
  //                         onChange={(e) => {
  //                           setBarChartYear(e.target.value);
  //                           handleBarChartYear(e.target.value);
  //                         }}
  //                         sx={{
  //                           borderRadius: 2,
  //                           "& .MuiOutlinedInput-notchedOutline": {
  //                             borderColor: theme.palette.primary.main + "30",
  //                           },
  //                           "&:hover .MuiOutlinedInput-notchedOutline": {
  //                             borderColor: theme.palette.primary.main + "60",
  //                           },
  //                         }}
  //                       >
  //                         {yearList.map((year) => (
  //                           <MenuItem key={year.value} value={year.value}>
  //                             {year.name}
  //                           </MenuItem>
  //                         ))}
  //                       </Select>
  //                     </FormControl>
  //                   )}
  //                   <Tooltip title="Refresh Data">
  //                     <IconButton
  //                       size="small"
  //                       onClick={() => getUserBarChartDetails(barChartYear)}
  //                       sx={{
  //                         color: theme.palette.primary.main,
  //                         "&:hover": {
  //                           bgcolor: theme.palette.primary.main + "10",
  //                           transform: "rotate(180deg)",
  //                         },
  //                         transition: "all 0.3s ease",
  //                       }}
  //                     >
  //                       <RefreshIcon />
  //                     </IconButton>
  //                   </Tooltip>
  //                 </Stack>
  //               }
  //             >
  //               {/* You'll need to replace this with your actual ApexChartsComp component */}
  //               <Box
  //                 sx={{
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                   height: "100%",
  //                   flexDirection: "column",
  //                   gap: 2,
  //                 }}
  //               >
  //                 <BarChartIcon
  //                   sx={{
  //                     fontSize: 64,
  //                     color: theme.palette.primary.main + "40",
  //                   }}
  //                 />
  //                 <Typography variant="body1" color="text.Primary">
  //                   Chart data will be displayed here
  //                 </Typography>
  //               </Box>
  //             </ChartContainer>
  //           </Grid2>
  //         </Grid2>

  //         {/* Notifications Section */}
  //         {notifications.length > 0 && (
  //           <Grid2 container spacing={4} sx={{ mb: 5 }}>
  //             <Grid2 item xs={12}>
  //               <Card
  //                 sx={{
  //                   background: `linear-gradient(135deg, ${theme.palette.info.light}12 0%, ${theme.palette.info.main}08 100%)`,
  //                   border: `2px solid ${theme.palette.info.light}30`,
  //                 }}
  //               >
  //                 <CardContent sx={{ p: 4 }}>
  //                   <Typography
  //                     variant="h6"
  //                     component="h2"
  //                     sx={{ fontWeight: 700, mb: 3, color: "info.main" }}
  //                   >
  //                     <NotificationIcon sx={{ mr: 2, verticalAlign: "middle" }} />
  //                     Recent Notifications
  //                   </Typography>
  //                   {/* You'll need to replace this with your actual RemainderComp component */}
  //                   <Box sx={{ p: 2 }}>
  //                     {notifications.map((notification, index) => (
  //                       <Alert
  //                         key={index}
  //                         severity="info"
  //                         sx={{ mb: 2, borderRadius: 2 }}
  //                       >
  //                         {notification.message || "New notification"}
  //                       </Alert>
  //                     ))}
  //                   </Box>
  //                 </CardContent>
  //               </Card>
  //             </Grid2>
  //           </Grid2>
  //         )}

  //         {/* Enhanced Quick Actions Section */}
  //         <Grid2 container spacing={4} sx={{ mb: 5 }}>
  //           <Grid2 item xs={12}>
  //             <Card
  //               sx={{
  //                 background: `linear-gradient(135deg, ${theme.palette.primary.light}12 0%, ${theme.palette.primary.main}08 100%)`,
  //                 border: `2px solid ${theme.palette.primary.light}30`,
  //               }}
  //             >
  //               <CardContent sx={{ p: 4 }}>
  //                 <Typography
  //                   variant="h6"
  //                   component="h2"
  //                   sx={{ fontWeight: 700, mb: 4, color: "primary.main" }}
  //                 >
  //                   <DashboardIcon sx={{ mr: 2, verticalAlign: "middle" }} />
  //                   Quick Actions
  //                 </Typography>

  //                 <Grid2 container spacing={3}>
  //                   <Grid2 item xs={12} sm={6} md={3}>
  //                     <Button
  //                       variant="outlined"
  //                       fullWidth
  //                       startIcon={<DocumentIcon />}
  //                       sx={{
  //                         py: 2.5,
  //                         borderRadius: 3,
  //                         borderWidth: 2,
  //                         fontWeight: 600,
  //                         textTransform: "none",
  //                         fontSize: "0.95rem",
  //                         "&:hover": {
  //                           transform: "translateY(-4px)",
  //                           boxShadow: theme.shadows[8],
  //                           borderWidth: 2,
  //                         },
  //                         transition:
  //                           "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  //                       }}
  //                       component={Link}
  //                       to="/mydocuments"
  //                     >
  //                       View All Documents
  //                     </Button>
  //                   </Grid2>

  //                   <Grid2 item xs={12} sm={6} md={3}>
  //                     <Button
  //                       variant="outlined"
  //                       fullWidth
  //                       startIcon={<PendingIcon />}
  //                       sx={{
  //                         py: 2.5,
  //                         borderRadius: 3,
  //                         borderWidth: 2,
  //                         fontWeight: 600,
  //                         textTransform: "none",
  //                         fontSize: "0.95rem",
  //                         color: "warning.main",
  //                         borderColor: "warning.main",
  //                         "&:hover": {
  //                           transform: "translateY(-4px)",
  //                           boxShadow: theme.shadows[8],
  //                           borderColor: "warning.main",
  //                           borderWidth: 2,
  //                           backgroundColor: "warning.light",
  //                           color: "warning.dark",
  //                         },
  //                         transition:
  //                           "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  //                       }}
  //                       component={Link}
  //                       to="/mydocuments"
  //                     >
  //                       Pending Approvals
  //                     </Button>
  //                   </Grid2>

  //                   <Grid2 item xs={12} sm={6} md={3}>
  //                     <Button
  //                       variant="outlined"
  //                       fullWidth
  //                       startIcon={<ChatIcon />}
  //                       sx={{
  //                         py: 2.5,
  //                         borderRadius: 3,
  //                         borderWidth: 2,
  //                         fontWeight: 600,
  //                         textTransform: "none",
  //                         fontSize: "0.95rem",
  //                         color: "success.main",
  //                         borderColor: "success.main",
  //                         "&:hover": {
  //                           transform: "translateY(-4px)",
  //                           boxShadow: theme.shadows[8],
  //                           borderColor: "success.main",
  //                           borderWidth: 2,
  //                           backgroundColor: "success.light",
  //                           color: "success.dark",
  //                         },
  //                         transition:
  //                           "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  //                       }}
  //                       component={Link}
  //                       to="/chat"
  //                     >
  //                       Open Chat
  //                     </Button>
  //                   </Grid2>

  //                   <Grid2 item xs={12} sm={6} md={3}>
  //                     <Button
  //                       variant="outlined"
  //                       fullWidth
  //                       startIcon={<SettingsIcon />}
  //                       sx={{
  //                         py: 2.5,
  //                         borderRadius: 3,
  //                         borderWidth: 2,
  //                         fontWeight: 600,
  //                         textTransform: "none",
  //                         fontSize: "0.95rem",
  //                         color: "secondary.main",
  //                         borderColor: "secondary.main",
  //                         "&:hover": {
  //                           transform: "translateY(-4px)",
  //                           boxShadow: theme.shadows[8],
  //                           borderColor: "secondary.main",
  //                           borderWidth: 2,
  //                           backgroundColor: "secondary.light",
  //                           color: "secondary.dark",
  //                         },
  //                         transition:
  //                           "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  //                       }}
  //                     >
  //                       Settings
  //                     </Button>
  //                   </Grid2>
  //                 </Grid2>
  //               </CardContent>
  //             </Card>
  //           </Grid2>
  //         </Grid2>

  //         {/* Enhanced Subscription Alert Dialog */}
  //         <Dialog
  //           open={showPopup}
  //           onClose={handleClose}
  //           PaperProps={{
  //             sx: {
  //               borderRadius: 4,
  //               minWidth: { xs: "90%", sm: "500px" },
  //               background: isDarkMode
  //                 ? `linear-gradient(135deg, ${theme.palette.error.dark}15 0%, ${theme.palette.error.main}10 100%)`
  //                 : `linear-gradient(135deg, ${theme.palette.error.light}15 0%, ${theme.palette.error.main}08 100%)`,
  //               backdropFilter: "blur(20px)",
  //               border: `2px solid ${theme.palette.error.main}30`,
  //             },
  //           }}
  //         >
  //           <DialogTitle
  //             sx={{
  //               display: "flex",
  //               justifyContent: "space-between",
  //               alignItems: "center",
  //               pb: 2,
  //               borderBottom: `1px solid ${theme.palette.divider}`,
  //             }}
  //           >
  //             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
  //               <Avatar
  //                 sx={{
  //                   bgcolor: theme.palette.error.main + "20",
  //                   color: theme.palette.error.main,
  //                   width: 48,
  //                   height: 48,
  //                 }}
  //               >
  //                 <NotificationIcon />
  //               </Avatar>
  //               <Typography
  //                 variant="h6"
  //                 sx={{ fontWeight: 700, color: "error.main" }}
  //               >
  //                 Subscription Plan Alert
  //               </Typography>
  //             </Box>
  //             <IconButton
  //               onClick={handleClose}
  //               size="small"
  //               sx={{
  //                 color: "error.main",
  //                 "&:hover": {
  //                   bgcolor: theme.palette.error.main + "10",
  //                 },
  //               }}
  //             >
  //               <CloseIcon />
  //             </IconButton>
  //           </DialogTitle>

  //           <DialogContent sx={{ pt: 3, pb: 2 }}>
  //             <Alert
  //               severity="warning"
  //               sx={{
  //                 mb: 3,
  //                 borderRadius: 3,
  //                 bgcolor: theme.palette.warning.main + "10",
  //                 border: `1px solid ${theme.palette.warning.main}30`,
  //                 "& .MuiAlert-icon": {
  //                   color: theme.palette.warning.main,
  //                 },
  //               }}
  //             >
  //               {alertForEndSub}
  //             </Alert>

  //             <Typography
  //               variant="body1"
  //               color="text.Primary"
  //               sx={{ lineHeight: 1.6 }}
  //             >
  //               Please consider renewing your subscription to continue enjoying
  //               all premium features and maintain uninterrupted access to your
  //               dashboard.
  //             </Typography>
  //           </DialogContent>

  //           <DialogActions sx={{ p: 3, pt: 1, gap: 2 }}>
  //             <Button
  //               onClick={handleClose}
  //               color="primary"
  //               variant="outlined"
  //               sx={{
  //                 borderRadius: 2,
  //                 px: 3,
  //                 py: 1,
  //                 fontWeight: 600,
  //               }}
  //             >
  //               Remind Later
  //             </Button>
  //             <Button
  //               onClick={handleClose}
  //               color="error"
  //               variant="contained"
  //               sx={{
  //                 borderRadius: 2,
  //                 px: 3,
  //                 py: 1,
  //                 fontWeight: 600,
  //                 boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  //                 "&:hover": {
  //                   boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
  //                 },
  //               }}
  //             >
  //               View Plans
  //             </Button>
  //           </DialogActions>
  //         </Dialog>
  //       </Box>
  //     </ThemeProvider>
  //   );
  // };

  // export default DashboardPage;



  import React, { useState, useEffect } from "react";
  import {
    Box,
    Card,
    CardContent,
    Typography,
    Avatar,
    IconButton,
    Container,
    Skeleton,
    Chip,
    Zoom,
    useTheme,
    useMediaQuery,
    ThemeProvider,
    createTheme,
    CssBaseline,
    LinearProgress,
    Alert,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Stack,
    Tooltip,
    Button,
     styled, tooltipClasses
  } from "@mui/material";
  import {
    Dashboard as DashboardIcon,
    Description as DocumentIcon,
    PendingActions as PendingIcon,
    Chat as ChatIcon,
    Notifications as NotificationIcon,
    Settings as SettingsIcon,
    Assessment as AssessmentIcon,
    Timeline as TimelineIcon,
    BarChart as BarChartIcon,
    Refresh as RefreshIcon,
    Close as CloseIcon,
  } from "@mui/icons-material";
  import DashboardServices from "../services/dashboardServices";
  import { toast, ToastContainer } from "react-toastify";
  import Loader from "../utils/loader";
  import { useSelector } from "react-redux";
  import { Link } from "react-router-dom";
  import { getnotifications } from "../services/notficationService";
  import StatusApexChartsComp from "./ReusableComponents/StatusApexChartsComp";
  import documentService from "../services/document";
  import moment from "moment/moment";
  import Grid2 from "@mui/material/Unstable_Grid2";

    const dashboardThemeBackground = (isDarkMode) => ({
    position: 'relative',
    minHeight: '100vh',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `
        /* Gradient overlays for depth */
        radial-gradient(circle at 5% 20%, ${isDarkMode ? 'rgba(25, 118, 210, 0.08)' : 'rgba(25, 118, 210, 0.05)'} 0%, transparent 35%),
        radial-gradient(circle at 95% 70%, ${isDarkMode ? 'rgba(156, 39, 176, 0.08)' : 'rgba(156, 39, 176, 0.05)'} 0%, transparent 40%),
        radial-gradient(circle at 30% 85%, ${isDarkMode ? 'rgba(46, 125, 50, 0.08)' : 'rgba(46, 125, 50, 0.05)'} 0%, transparent 30%),
        
        /* Dashboard visualization elements - charts and graphs */
        url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400' viewBox='0 0 400 400'%3E%3C!-- Bar Chart Element --%3E%3Crect x='50' y='250' width='40' height='100' fill='%231976d2' opacity='0.05' /%3E%3Crect x='100' y='200' width='40' height='150' fill='%231976d2' opacity='0.05' /%3E%3Crect x='150' y='150' width='40' height='200' fill='%231976d2' opacity='0.05' /%3E%3Crect x='200' y='180' width='40' height='170' fill='%231976d2' opacity='0.05' /%3E%3Crect x='250' y='220' width='40' height='130' fill='%231976d2' opacity='0.05' /%3E%3C!-- Pie Chart Element --%3E%3Ccircle cx='300' cy='100' r='50' fill='none' stroke='%239c27b0' stroke-width='2' opacity='0.08' /%3E%3Cpath d='M300 100 L300 50 A50 50 0 0 1 350 100 Z' fill='%239c27b0' opacity='0.08' /%3E%3Cpath d='M300 100 L350 100 A50 50 0 0 1 300 150 Z' fill='%239c27b0' opacity='0.08' /%3E%3C!-- Line Graph Element --%3E%3Cpath d='M30 350 L80 320 L130 280 L180 250 L230 200 L280 220 L330 180' stroke='%232e7d32' stroke-width='2' fill='none' opacity='0.08' /%3E%3Ccircle cx='80' cy='320' r='3' fill='%232e7d32' opacity='0.08' /%3E%3Ccircle cx='130' cy='280' r='3' fill='%232e7d32' opacity='0.08' /%3E%3Ccircle cx='180' cy='250' r='3' fill='%232e7d32' opacity='0.08' /%3E%3Ccircle cx='230' cy='200' r='3' fill='%232e7d32' opacity='0.08' /%3E%3Ccircle cx='280' cy='220' r='3' fill='%232e7d32' opacity='0.08' /%3E%3Ccircle cx='330' cy='180' r='3' fill='%232e7d32' opacity='0.08' /%3E%3C!-- Document Icons --%3E%3Crect x='30' y='50' width='30' height='40' fill='%23ed6c02' opacity='0.05' /%3E%3Cline x1='35' y1='60' x2='55' y2='60' stroke='%23ed6c02' stroke-width='1' opacity='0.05' /%3E%3Cline x1='35' y1='70' x2='55' y2='70' stroke='%23ed6c02' stroke-width='1' opacity='0.05' /%3E%3Cline x1='35' y1='80' x2='55' y2='80' stroke='%23ed6c02' stroke-width='1' opacity='0.05' /%3E%3C!-- Stats Cards Visualization --%3E%3Crect x='120' y='30' width='60' height='50' rx='5' fill='%231976d2' opacity='0.03' /%3E%3Ccircle cx='140' cy='45' r='8' fill='%231976d2' opacity='0.08' /%3E%3Cline x1='160' y1='45' x2='170' y2='45' stroke='%231976d2' stroke-width='2' opacity='0.08' /%3E%3C/svg%3E")
        
        /* Subtle pattern overlay */
        ${isDarkMode ? ', repeating-linear-gradient(45deg, rgba(255,255,255,0.01) 0px, rgba(255,255,255,0.01) 2px, transparent 2px, transparent 30px)' : ', repeating-linear-gradient(45deg, rgba(0,0,0,0.01) 0px, rgba(0,0,0,0.01) 2px, transparent 2px, transparent 30px)'}
      `,
      backgroundSize: '800px 800px, 400px 400px, auto',
      backgroundRepeat: 'repeat, repeat, repeat',
      backgroundPosition: '0 0, 100px 100px, 0 0',
      backgroundAttachment: 'fixed, fixed, fixed',
      pointerEvents: 'none',
      zIndex: 0,
      animation: 'slowDrift 120s linear infinite',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '15%',
      right: '10%',
      width: '500px',
      height: '500px',
      background: `radial-gradient(circle, ${isDarkMode ? 'rgba(156,39,176,0.03)' : 'rgba(156,39,176,0.02)'} 0%, transparent 70%)`,
      borderRadius: '50%',
      pointerEvents: 'none',
      zIndex: 0,
      animation: 'pulse 8s ease-in-out infinite',
    },
    '& > *': {
      position: 'relative',
      zIndex: 1,
    },
    '@keyframes slowDrift': {
      '0%': {
        backgroundPosition: '0 0, 100px 100px, 0 0',
      },
      '100%': {
        backgroundPosition: '500px 500px, 600px 600px, 500px 500px',
      },
    },
    '@keyframes pulse': {
      '0%, 100%': {
        opacity: 0.5,
        transform: 'scale(1)',
      },
      '50%': {
        opacity: 1,
        transform: 'scale(1.05)',
      },
    },
  });

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "blue",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    borderRadius: 8,
    padding: "6px 10px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
}));

  // Enhanced Material-UI Theme
  const createCustomTheme = (isDarkMode) =>
    createTheme({
      palette: {
        mode: isDarkMode ? "dark" : "light",
        primary: {
          main: "#1976d2",
          light: "#42a5f5",
          dark: "#1565c0",
        },
        secondary: {
          main: "#9c27b0",
          light: "#ba68c8",
          dark: "#7b1fa2",
        },
        success: {
          main: "#2e7d32",
          light: "#4caf50",
          dark: "#1b5e20",
        },
        warning: {
          main: "#ed6c02",
          light: "#ff9800",
          dark: "#e65100",
        },
        error: {
          main: "#d32f2f",
          light: "#f44336",
          dark: "#c62828",
        },
        background: {
          default: isDarkMode ? "#0a0e1a" : "#f8fafc",
          paper: isDarkMode ? "#1a1f2e" : "#ffffff",
        },
        text: {
          primary: isDarkMode ? "#ffffff" : "#1a202c",
          secondary: isDarkMode ? "#a0aec0" : "#4a5568",
        },
      },
      typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h4: {
          fontWeight: 700,
          fontSize: "2.25rem",
          letterSpacing: "-0.025em",
        },
        h5: {
          fontWeight: 600,
          fontSize: "1.75rem",
          letterSpacing: "-0.025em",
        },
        h6: {
          fontWeight: 600,
          fontSize: "1.25rem",
          letterSpacing: "-0.025em",
        },
        subtitle1: {
          fontWeight: 500,
          fontSize: "1rem",
          lineHeight: 1.5,
        },
        body1: {
          fontSize: "0.875rem",
          lineHeight: 1.6,
        },
      },
      shape: {
        borderRadius: 16,
      },
      components: {
        MuiCard: {
          styleOverrides: {
            root: {
              boxShadow: isDarkMode
                ? "0 10px 40px rgba(0,0,0,0.4), 0 2px 8px rgba(0,0,0,0.2)"
                : "0 10px 40px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)",
              borderRadius: 20,
              transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
              border: isDarkMode
                ? "1px solid rgba(255,255,255,0.1)"
                : "1px solid rgba(0,0,0,0.05)",
              background: isDarkMode
                ? "linear-gradient(135deg, rgba(255,255,255,0.02) 0%, rgba(255,255,255,0.05) 100%)"
                : "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.95) 100%)",
              backdropFilter: "blur(20px)",
              "&:hover": {
                transform: "translateY(-8px) scale(1.02)",
                boxShadow: isDarkMode
                  ? "0 20px 60px rgba(0,0,0,0.5), 0 8px 16px rgba(0,0,0,0.3)"
                  : "0 20px 60px rgba(0,0,0,0.12), 0 8px 16px rgba(0,0,0,0.08)",
              },
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            root: {
              borderRadius: 12,
              textTransform: "none",
              fontWeight: 600,
              padding: "10px 24px",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
                transform: "translateY(-2px)",
              },
            },
          },
        },
        MuiPaper: {
          styleOverrides: {
            root: {
              backgroundImage: "none",
            },
          },
        },
      },
    });

  // Enhanced Stat Card Component
  const StatCard = ({ title, value, icon, color, trend, isLoading, onClick }) => {
    const theme = useTheme();

    return (
      <Zoom in={!isLoading} style={{ transitionDelay: "100ms" }}>
        <Card
          sx={{
            height: "100%",
            cursor: onClick ? "pointer" : "default",
            background: `linear-gradient(135deg, ${color}15 0%, ${color}08 50%, ${color}03 100%)`,
            border: `2px solid ${color}20`,
            position: "relative",
            overflow: "hidden",
            "&:hover": onClick
              ? {
                  transform: "translateY(-8px) scale(1.02)",
                  boxShadow: `0 20px 40px ${color}25`,
                  border: `2px solid ${color}40`,
                }
              : {},
            "&::before": {
              content: '""',
              position: "absolute",
              top: -50,
              right: -50,
              width: "150px",
              height: "150px",
              background: `radial-gradient(circle, ${color}20 0%, transparent 70%)`,
              borderRadius: "50%",
            },
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: -30,
              left: -30,
              width: "100px",
              height: "100px",
              background: `linear-gradient(45deg, ${color}10, transparent)`,
              borderRadius: "50%",
            },
          }}
          onClick={onClick}
        >
          <CardContent sx={{ position: "relative", zIndex: 1, p: 3 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 3,
              }}
            >
              <Avatar
                sx={{
                  bgcolor: `${color}25`,
                  color: color,
                  width: 64,
                  height: 64,
                  boxShadow: `0 8px 20px ${color}30`,
                }}
              >
                {icon}
              </Avatar>
              {trend && (
                <Chip
                  label={trend}
                  size="small"
                  sx={{
                    bgcolor: trend.includes("+")
                      ? theme.palette.success.main
                      : theme.palette.error.main,
                    color: "white",
                    fontWeight: 700,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                />
              )}
            </Box>

            {isLoading ? (
              <Box>
                <Skeleton variant="text" width="60%" height={36} />
                <Skeleton variant="text" width="40%" height={28} />
              </Box>
            ) : (
              <Box>
                <Typography
                  variant="h4"
                  component="div"
                  sx={{
                    fontWeight: 800,
                    color: color,
                    mb: 1,
                    textShadow: `0 2px 4px ${color}20`,
                  }}
                >
                  {value}
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="text.Primary"
                  sx={{ fontWeight: 600, opacity: 0.8 }}
                >
                  {title}
                </Typography>
              </Box>
            )}
          </CardContent>
        </Card>
      </Zoom>
    );
  };

  // Enhanced Chart Container Component
  const ChartContainer = ({
    title,
    children,
    actions,
    isLoading,
    height = 400,
    icon,
    gradientColors,
  }) => {
    const theme = useTheme();

    return (
      <Card
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          background: gradientColors
            ? `linear-gradient(135deg, ${gradientColors[0]}08 0%, ${gradientColors[1]}05 50%, ${gradientColors[0]}03 100%)`
            : undefined,
          border: gradientColors ? `1px solid ${gradientColors[0]}20` : undefined,
          backdropFilter: "blur(10px)",
        }}
      >
        <CardContent
          sx={{ flexGrow: 1, display: "flex", flexDirection: "column", p: 3 }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 3,
              pb: 2,
              borderBottom: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {icon && (
                <Avatar
                  sx={{
                    bgcolor: gradientColors
                      ? `${gradientColors[0]}20`
                      : "primary.light",
                    color: gradientColors ? gradientColors[0] : "primary.main",
                    width: 48,
                    height: 48,
                  }}
                >
                  {icon}
                </Avatar>
              )}
              <Typography
                variant="h6"
                component="h2"
                sx={{
                  fontWeight: 700,
                  color: gradientColors ? gradientColors[0] : "text.primary",
                  textShadow: gradientColors
                    ? `0 1px 2px ${gradientColors[0]}20`
                    : undefined,
                }}
              >
                {title}
              </Typography>
            </Box>
            {actions && (
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                {actions}
              </Box>
            )}
          </Box>

          {isLoading ? (
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Skeleton
                variant="rectangular"
                height={height - 120}
                sx={{ borderRadius: 2 }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                minHeight: height - 120,
              }}
            >
              {children}
            </Box>
          )}
        </CardContent>
      </Card>
    );
  };

  const DashboardPage = () => {
    const [loading, setLoading] = useState(false);
    const [selectYear, setSelectYear] = useState(new Date().getFullYear());
    const [selectMonth, setSelectMonth] = useState(new Date().getMonth() + 1);

    // FIXED: Updated years array to include current year (2026)
    const [years, setYears] = useState(() => {
      const currentYear = new Date().getFullYear();
      // Start from 2019 to current year (inclusive)
      const yearsArray = [];
      for (let year = 2019; year <= currentYear; year++) {
        yearsArray.push(year);
      }
      return yearsArray;
    });

    const [selected, setSelected] = useState(new Date().getFullYear());
    const [totalMyDocs, setTotalMyDocs] = useState(0);
    const [totalSharedDocs, setTotalSharedDocs] = useState(0);
    const [imageCardData, setImageCardData] = useState({
      totalDocuments: "0",
      pendingForApproval: "0",
      unreadMsgCount: "0",
    });
    const userDetails = useSelector((state) => state.user);
    const isGuest = localStorage.getItem("is_guest");

    const userID = userDetails?.currentUser?._id;

    const userRole = sessionStorage.getItem("Role");
    const [yearList, setYearList] = useState(() => {
      const currentYear = new Date().getFullYear();
      const yearsArray = [];
      for (let year = 2019; year <= currentYear; year++) {
        yearsArray.push({ name: year.toString(), value: year });
      }
      return yearsArray;
    });
    const [teamList, setTeamList] = useState([]);
    const [barChartYear, setBarChartYear] = useState(new Date().getFullYear());
    const [statusChartYear, setStatusChartYear] = useState(
      new Date().getFullYear(),
    );
    const [selectedMember, setSelectedMember] = useState();
    const [isBarChartDropdown, setIsBarChartDropdown] = useState(false);
    const [isPieChartDropdown, setIsPieChartDropdown] = useState(false);
    const [barChartData, setBarChartData] = useState({
      bar1Count: 0,
      bar2Count: 0,
      chartHeading: "Documents & Reviews",
      bar1Name: `Documents(0)`,
      bar2Name: `Reviews(0)`,
      xAxis: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "June",
        "July",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ],
      bar1Datas: [],
      bar2Data: [],
    });
    const [barDocsStatusChartData, setBarDocsStatusChartData] = useState({
      chartHeading: "Documents & Reviews Status",
      bar1Name: "Documents",
      bar2Name: "Reviews",
      xAxis: ["Pending", "Progress", "Completed", "Rejected", "Published"],
      counts: [],
    });
    const [notifications, setNotifications] = useState([]);
    const [isDarkMode, setIsDarkMode] = useState(false);
    const screenData = useSelector(
      (state) => state.manageSubscriptionPlan.subscriptionPlan,
    );
    const [alertForEndSub, setAlertForEndSub] = useState("");
    const [showPopup, setShowPopup] = useState(false);

    const theme = createCustomTheme(isDarkMode);
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const isTablet = useMediaQuery(theme.breakpoints.down("lg"));

    // ✅ Guest demo data
    useEffect(() => {
      if (isGuest) {
        setTotalMyDocs(12);
        setTotalSharedDocs(4);

        setImageCardData({
          totalDocuments: "16",
          pendingForApproval: "3",
          unreadMsgCount: "5",
        });

        setBarChartData((prev) => ({
          ...prev,
          bar1Datas: [2, 3, 4, 5, 6, 4, 3, 2, 1, 3, 5, 4],
          bar2Data: [1, 2, 1, 2, 3, 2, 1, 1, 2, 2, 3, 2],
          bar1Count: 42,
          bar2Count: 22,
          bar1Name: "Documents(42)",
          bar2Name: "Reviews(22)",
        }));

        setBarDocsStatusChartData((prev) => ({
          ...prev,
          counts: [3, 5, 8, 2, 6],
        }));
      }
    }, [isGuest]);

    useEffect(() => {
      const alertShown = sessionStorage.getItem("subscriptionAlertShown");
      const roleOfUser = sessionStorage.getItem("Role");

      const checkSubscriptionExpiry = () => {
        if (
          !alertShown &&
          screenData?.isDefault == false &&
          roleOfUser == "Individual"
        ) {
          const now = moment().startOf("day");
          const expiryDate = moment(screenData?.endDate).startOf("day");
          const daysLeft = expiryDate.diff(now, "days");

          if (daysLeft >= 1 && daysLeft <= 5) {
            setAlertForEndSub(
              `Your subscription will expire in ${daysLeft} day(s) on ${expiryDate.format(
                "D MMMM YYYY",
              )}.`,
            );
            setShowPopup(true);
          } else if (daysLeft === 0) {
            setAlertForEndSub(
              `Your subscription expires today on ${expiryDate.format(
                "D MMMM YYYY",
              )}.`,
            );
            setShowPopup(true);
          } else {
            setAlertForEndSub("");
          }
          if ((daysLeft >= 1 && daysLeft <= 5) || daysLeft === 0) {
            sessionStorage.setItem("subscriptionAlertShown", "true");
          }
        }
      };

      checkSubscriptionExpiry();
    }, [screenData?.endDate]);

    const handleClose = () => {
      setShowPopup(false);
    };

    useEffect(() => {
      const updateTheme = () => {
        const theme = localStorage.getItem("ThemeSwitch");
        setIsDarkMode(theme === "true");
      };
      updateTheme();
      window.addEventListener("storage", updateTheme);
      const originalSetItem = localStorage.setItem;
      localStorage.setItem = function (key, value) {
        originalSetItem.apply(this, arguments);
        if (key === "ThemeSwitch") {
          updateTheme();
        }
      };
      return () => {
        window.removeEventListener("storage", updateTheme);
        localStorage.setItem = originalSetItem;
      };
    }, []);

    const { leftNavbarOpen } = useSelector(
      (state) => state.handleModelAndSideBavBar,
    );

    // Initialize year list dynamically
    useEffect(() => {
      const currentYear = new Date().getFullYear();
      const yearsArray = [];
      for (let year = 2019; year <= currentYear; year++) {
        yearsArray.push({ name: year.toString(), value: year });
      }
      setYearList(yearsArray);
      setYears(yearsArray.map((y) => y.value));
      setIsBarChartDropdown(true);
    }, []);

    useEffect(() => {
      if (!isGuest) {
        fetchYearList();
        getUserDashCardDetails();
        getUserBarChartDetails(barChartYear);
      }
    }, [isGuest]);

    const fetchYearList = async () => {
      setLoading(true);
      try {
        let response = await DashboardServices.getYearList();
        console.log("fetchYearList", response);
        if (response.status == 200) {
          // Ensure current year is included
          const currentYear = new Date().getFullYear();
          const serverYears = response.yearList || [];

          // Check if current year is in the list
          if (!serverYears.includes(currentYear)) {
            serverYears.push(currentYear);
            serverYears.sort((a, b) => a - b);
          }

          let finalArr = serverYears.map((year) => ({
            name: year.toString(),
            value: year,
          }));
          setYearList(finalArr);
          setYears(serverYears);
          setIsBarChartDropdown(true);
        }
      } catch (error) {
        console.log("error", error);
        // Fallback: create years array manually
        const currentYear = new Date().getFullYear();
        const yearsArray = [];
        for (let year = 2019; year <= currentYear; year++) {
          yearsArray.push(year);
        }
        const finalArr = yearsArray.map((year) => ({
          name: year.toString(),
          value: year,
        }));
        setYearList(finalArr);
        setYears(yearsArray);
        setIsBarChartDropdown(true);
      }
      setLoading(false);
    };

    const fetchTeamList = async () => {
      setLoading(true);
      try {
        let response = await DashboardServices.getTeamMembersDetails(userID);
        console.log("fetchTeamList", response);
        let finalArr = [];
        response.memberNames.map((obj) =>
          finalArr.push({ name: obj.name, value: obj.id }),
        );
        setTeamList(finalArr);
        setIsPieChartDropdown(true);
      } catch (error) {
        console.log("error", error);
      }
      setLoading(false);
    };

    const getDocs = async () => {
      try {
        const response = await documentService.getAllMyDocuments();
        if (response.status === 200) {
          setTotalMyDocs(response.data.length);
        } else {
          console.error("Error fetching data:", response.message);
        }
      } catch (error) {
        console.error("Error calling backend API:", error.message);
      }
    };

    const getSharedDocs = async () => {
      try {
        const response = await documentService.getSharedDocuments();
        if (response.status === 200) {
          setTotalSharedDocs(response.data.length);
        } else {
          console.error("Error fetching data:", response.message);
        }
      } catch (error) {
        console.error("Error calling backend API:", error.message);
      }
    };

    useEffect(() => {
      if (!isGuest) {
        getDocs();
        getSharedDocs();
      }
    }, [isGuest]);

    const getUserDashCardDetails = async () => {
      setLoading(true);
      try {
        let response = await DashboardServices.getIndividualDashCards(userID);
        console.log("getUserDashCardDetails", response);
        let { totalDocuments, pendingForApproval, unreadMsgCount } = response;
        setImageCardData({
          totalDocuments: totalDocuments,
          pendingForApproval: pendingForApproval,
          unreadMsgCount: unreadMsgCount,
        });
      } catch (error) {
        console.log("error", error);
      }
      setLoading(false);
    };

    const getUserBarChartDetails = async (year) => {
      setLoading(true);
      try {
        let response = await DashboardServices.getIndividualBarChart(
          userID,
          year,
        );
        console.log("getUserBarChartDetails", response);
        let { bar1, bar2, bar1Count, bar2Count } = response;
        setBarChartData((prevState) => ({
          ...prevState,
          bar1Datas: bar1,
          bar2Data: bar2,
          bar1Count: bar1Count,
          bar2Count: bar2Count,
          bar1Name: `Documents(${bar1Count})`,
          bar2Name: `Reviews(${bar2Count})`,
        }));
        let isBar1 = bar1.some((obj) => obj > 0);
        let isBar2 = bar2.some((obj) => obj > 0);
        if (!isBar1 && !isBar2) {
          // toast.warn("No records were found")
        }
      } catch (error) {
        console.log("error", error);
      }
      setLoading(false);
    };

    const handleFetchStatus = async (year = statusChartYear) => {
      try {
        let response = await DashboardServices.getDocsStatusBarChart(
          userID,
          year,
        );
        console.log("statusdata", response);
        let bar1 = response.counts;
        console.log("bar1:", bar1);
        setBarDocsStatusChartData({ ...barDocsStatusChartData, counts: bar1 });
        console.log("bar1status2", bar1);
        let isBar1 = bar1.some((obj) => obj > 0);
        if (!isBar1) {
          // toast.warn("No records were found")
        }
      } catch (error) {
        console.log("error", error);
      }
    };

    useEffect(() => {
      if (!isGuest) {
        handleFetchStatus();
      }
    }, [isGuest]);

    const handleBarChartYear = (year) => {
      console.log("handleBarChartYear", year);
      let currentYear = new Date().getFullYear();
      if (year > currentYear) {
        toast.warn("Please enter current or past year");
        return;
      }
      getUserBarChartDetails(year);
    };

    const handleStatusChartYear = (year) => {
      console.log("handleStatusChartYear", year);
      let currentYear = new Date().getFullYear();
      if (year > currentYear) {
        toast.warn("Please enter current or past year");
        return;
      }
      setStatusChartYear(year);
      handleFetchStatus(year);
    };

    const getNotifications = async () => {
      try {
        let notifications = await getnotifications();
        console.log("notifications", notifications);
        setNotifications(notifications || []);
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setNotifications([]);
      }
    };

    useEffect(() => {
      if (!isGuest) {
        getNotifications();
      }
    }, [isGuest]);

    const statsData = [
      {
        title: "Total Documents",
        value: (totalMyDocs + totalSharedDocs).toString() || "0",
        icon: <DocumentIcon />,
        color: theme.palette.primary.main,
        link: "/mydocuments",
      },
      {
        title: "Pending Approval",
        value: imageCardData.pendingForApproval || "0",
        icon: <PendingIcon />,
        color: theme.palette.warning.main,
        link: "/mydocuments",
      },
      {
        title: "Workspace Chats",
        value: imageCardData.unreadMsgCount || "0",
        icon: <ChatIcon />,
        color: theme.palette.success.main,
        link: "/chat",
      },
    ];
    const shouldWaitForUser = !isGuest && !userID;

    return shouldWaitForUser ? (
      <Loader loading={true} />
    ) : (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box
          sx={{
            flexGrow: 1,
            minHeight: "100vh",
            p: { xs: 2, md: 4 },
            // Apply the enhanced dashboard theme background
            ...dashboardThemeBackground(isDarkMode),
            // Keep your existing background as fallback
            background: isDarkMode
              ? "radial-gradient(ellipse at top, #1a1f2e 0%, #0a0e1a 100%)"
              : "radial-gradient(ellipse at top, #f8fafc 0%, #e2e8f0 100%)",
          }}
        >
          <ToastContainer />
          <Loader loading={loading} />

          {/* Enhanced Header Section */}
          <Box sx={{ mb: 5 }}>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 800,
                color: "primary.main",
                mb: 1,
              }}
            >
              Dashboard Analytics
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.primary"
              sx={{
                fontWeight: 500,
                opacity: 0.8,
              }}
            >
              Welcome back! Here's what's happening with your documents today.
            </Typography>
          </Box>

          {/* Stats Cards Section */}
          <Grid2 container spacing={4} sx={{ mb: 5 }}>
            {statsData.map((stat, index) => (
              <Grid2 item xs={12} sm={6} md={4} key={index}>
                <Link to={stat.link} style={{ textDecoration: "none" }}>
                  <StatCard
                    title={stat.title}
                    value={stat.value}
                    icon={stat.icon}
                    color={stat.color}
                    trend={stat.trend}
                    isLoading={loading}
                    onClick={() => {}}
                  />
                </Link>
              </Grid2>
            ))}
          </Grid2>

          {/* Enhanced Side-by-Side Charts Section */}
          <Grid2 container spacing={4} sx={{ mb: 5 }}>
            {/* Documents & Reviews Status Chart */}
            <Grid2 item xs={12} lg={5}>
              <ChartContainer
                title="Documents & Reviews Status"
                isLoading={loading}
                height={320}
                icon={<AssessmentIcon />}
                gradientColors={[
                  theme.palette.warning.main,
                  theme.palette.warning.light,
                ]}
                actions={
                  isBarChartDropdown && (
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Chip
                        label="Status"
                        size="small"
                        sx={{
                          bgcolor: theme.palette.warning.light + "20",
                          color: theme.palette.warning.main,
                          fontWeight: 600,
                          border: `1px solid ${theme.palette.warning.main}30`,
                          fontSize: "0.75rem",
                        }}
                      />
                      <FormControl size="small" sx={{ minWidth: 100 }}>
                        <InputLabel>Year</InputLabel>
                        <Select
                          value={statusChartYear}
                          label="Year"
                          onChange={(e) => {
                            handleStatusChartYear(e.target.value);
                          }}
                          sx={{
                            borderRadius: 2,
                            fontSize: "0.875rem",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: theme.palette.warning.main + "30",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: theme.palette.warning.main + "60",
                            },
                          }}
                        >
                          {yearList.map((year) => (
                            <MenuItem key={year.value} value={year.value}>
                              {year.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Stack>
                  )
                }
              >
                <StatusApexChartsComp
                  chartHeading=""
                  cmp1={barChartData.bar1Name}
                  cmp2={barChartData.bar2Name}
                  bar1={barDocsStatusChartData.counts}
                  xAxisList={barDocsStatusChartData.xAxis}
                  isSelectDropdownShown={false}
                  barChartSelectOptions={yearList}
                  barChartValue={statusChartYear}
                  barChartSelectLabel="Year"
                  isDarkMode={isDarkMode}
                />
              </ChartContainer>
            </Grid2>

            {/* Documents & Reviews Analytics Chart */}
            <Grid2 item xs={12} lg={7}>
              <ChartContainer
                title="Documents & Reviews Analytics"
                isLoading={loading}
                height={320}
                icon={<TimelineIcon />}
                gradientColors={[
                  theme.palette.primary.main,
                  theme.palette.primary.light,
                ]}
                actions={
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Chip
                      label={`Documents: ${barChartData.bar1Count}`}
                      size="small"
                      sx={{
                        bgcolor: theme.palette.primary.light + "20",
                        color: theme.palette.primary.main,
                        fontWeight: 600,
                        border: `1px solid ${theme.palette.primary.main}30`,
                      }}
                    />
                    <Chip
                      label={`Reviews: ${barChartData.bar2Count}`}
                      size="small"
                      sx={{
                        bgcolor: theme.palette.secondary.light + "20",
                        color: theme.palette.secondary.main,
                        fontWeight: 600,
                        border: `1px solid ${theme.palette.secondary.main}30`,
                      }}
                    />
                    {isBarChartDropdown && (
                      <FormControl size="small" sx={{ minWidth: 120 }}>
                        <InputLabel>Year</InputLabel>
                        <Select
                          value={barChartYear}
                          label="Year"
                          onChange={(e) => {
                            setBarChartYear(e.target.value);
                            handleBarChartYear(e.target.value);
                          }}
                          sx={{
                            borderRadius: 2,
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: theme.palette.primary.main + "30",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: theme.palette.primary.main + "60",
                            },
                          }}
                        >
                          {yearList.map((year) => (
                            <MenuItem key={year.value} value={year.value}>
                              {year.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                    <LightTooltip  title="Refresh Data">
                      <IconButton
                        size="small"
                        onClick={() => getUserBarChartDetails(barChartYear)}
                        sx={{
                          color: theme.palette.primary.main,
                          "&:hover": {
                            bgcolor: theme.palette.primary.main + "10",
                            transform: "rotate(180deg)",
                          },
                          transition: "all 0.3s ease",
                        }}
                      >
                        <RefreshIcon />
                      </IconButton>
                    </LightTooltip>
                  </Stack>
                }
              >
                {/* You'll need to replace this with your actual ApexChartsComp component */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  <BarChartIcon
                    sx={{
                      fontSize: 64,
                      color: theme.palette.primary.main + "40",
                    }}
                  />
                  <Typography variant="body1" color="text.Primary">
                    Chart data will be displayed here
                  </Typography>
                </Box>
              </ChartContainer>
            </Grid2>
          </Grid2>

          {/* Notifications Section */}
          {notifications.length > 0 && (
            <Grid2 container spacing={4} sx={{ mb: 5 }}>
              <Grid2 item xs={12}>
                <Card
                  sx={{
                    background: `linear-gradient(135deg, ${theme.palette.info.light}12 0%, ${theme.palette.info.main}08 100%)`,
                    border: `2px solid ${theme.palette.info.light}30`,
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <CardContent sx={{ p: 4 }}>
                    <Typography
                      variant="h6"
                      component="h2"
                      sx={{ fontWeight: 700, mb: 3, color: "info.main" }}
                    >
                      <NotificationIcon sx={{ mr: 2, verticalAlign: "middle" }} />
                      Recent Notifications
                    </Typography>
                    {/* You'll need to replace this with your actual RemainderComp component */}
                    <Box sx={{ p: 2 }}>
                      {notifications.map((notification, index) => (
                        <Alert
                          key={index}
                          severity="info"
                          sx={{ mb: 2, borderRadius: 2 }}
                        >
                          {notification.message || "New notification"}
                        </Alert>
                      ))}
                    </Box>
                  </CardContent>
                </Card>
              </Grid2>
            </Grid2>
          )}

          {/* Enhanced Quick Actions Section */}
          <Grid2 container spacing={4} sx={{ mb: 5 }}>
            <Grid2 item xs={12}>
              <Card
                sx={{
                  background: `linear-gradient(135deg, ${theme.palette.primary.light}12 0%, ${theme.palette.primary.main}08 100%)`,
                  border: `2px solid ${theme.palette.primary.light}30`,
                  backdropFilter: "blur(10px)",
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Typography
                    variant="h6"
                    component="h2"
                    sx={{ fontWeight: 700, mb: 4, color: "primary.main" }}
                  >
                    <DashboardIcon sx={{ mr: 2, verticalAlign: "middle" }} />
                    Quick Actions
                  </Typography>

                  <Grid2 container spacing={3}>
                    <Grid2 item xs={12} sm={6} md={3}>
                      <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<DocumentIcon />}
                        sx={{
                          py: 2.5,
                          borderRadius: 3,
                          borderWidth: 2,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: "0.95rem",
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: theme.shadows[8],
                            borderWidth: 2,
                          },
                          transition:
                            "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                        }}
                        component={Link}
                        to="/mydocuments"
                      >
                        View All Documents
                      </Button>
                    </Grid2>

                    <Grid2 item xs={12} sm={6} md={3}>
                      <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<PendingIcon />}
                        sx={{
                          py: 2.5,
                          borderRadius: 3,
                          borderWidth: 2,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: "0.95rem",
                          color: "warning.main",
                          borderColor: "warning.main",
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: theme.shadows[8],
                            borderColor: "warning.main",
                            borderWidth: 2,
                            backgroundColor: "warning.light",
                            color: "warning.dark",
                          },
                          transition:
                            "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                        }}
                        component={Link}
                        to="/mydocuments"
                      >
                        Pending Approvals
                      </Button>
                    </Grid2>

                    <Grid2 item xs={12} sm={6} md={3}>
                      <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<ChatIcon />}
                        sx={{
                          py: 2.5,
                          borderRadius: 3,
                          borderWidth: 2,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: "0.95rem",
                          color: "success.main",
                          borderColor: "success.main",
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: theme.shadows[8],
                            borderColor: "success.main",
                            borderWidth: 2,
                            backgroundColor: "success.light",
                            color: "success.dark",
                          },
                          transition:
                            "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                        }}
                        component={Link}
                        to="/chat"
                      >
                        Open Chat
                      </Button>
                    </Grid2>

                    <Grid2 item xs={12} sm={6} md={3}>
                      <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<SettingsIcon />}
                        sx={{
                          py: 2.5,
                          borderRadius: 3,
                          borderWidth: 2,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: "0.95rem",
                          color: "secondary.main",
                          borderColor: "secondary.main",
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: theme.shadows[8],
                            borderColor: "secondary.main",
                            borderWidth: 2,
                            backgroundColor: "secondary.light",
                            color: "secondary.dark",
                          },
                          transition:
                            "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                        }}
                        component={Link}
                        to="/accountsettings"
                      >
                        Settings
                      </Button>
                    </Grid2>
                  </Grid2>
                </CardContent>
              </Card>
            </Grid2>
          </Grid2>

          {/* Enhanced Subscription Alert Dialog */}
          <Dialog
            open={showPopup}
            onClose={handleClose}
            PaperProps={{
              sx: {
                borderRadius: 4,
                minWidth: { xs: "90%", sm: "500px" },
                background: isDarkMode
                  ? `linear-gradient(135deg, ${theme.palette.error.dark}15 0%, ${theme.palette.error.main}10 100%)`
                  : `linear-gradient(135deg, ${theme.palette.error.light}15 0%, ${theme.palette.error.main}08 100%)`,
                backdropFilter: "blur(20px)",
                border: `2px solid ${theme.palette.error.main}30`,
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                pb: 2,
                borderBottom: `1px solid ${theme.palette.divider}`,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Avatar
                  sx={{
                    bgcolor: theme.palette.error.main + "20",
                    color: theme.palette.error.main,
                    width: 48,
                    height: 48,
                  }}
                >
                  <NotificationIcon />
                </Avatar>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "error.main" }}
                >
                  Subscription Plan Alert
                </Typography>
              </Box>
              <IconButton
                onClick={handleClose}
                size="small"
                sx={{
                  color: "error.main",
                  "&:hover": {
                    bgcolor: theme.palette.error.main + "10",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: 3, pb: 2 }}>
              <Alert
                severity="warning"
                sx={{
                  mb: 3,
                  borderRadius: 3,
                  bgcolor: theme.palette.warning.main + "10",
                  border: `1px solid ${theme.palette.warning.main}30`,
                  "& .MuiAlert-icon": {
                    color: theme.palette.warning.main,
                  },
                }}
              >
                {alertForEndSub}
              </Alert>

              <Typography
                variant="body1"
                color="text.Primary"
                sx={{ lineHeight: 1.6 }}
              >
                Please consider renewing your subscription to continue enjoying
                all premium features and maintain uninterrupted access to your
                dashboard.
              </Typography>
            </DialogContent>

            <DialogActions sx={{ p: 3, pt: 1, gap: 2 }}>
              <Button
                onClick={handleClose}
                color="primary"
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  fontWeight: 600,
                }}
              >
                Remind Later
              </Button>
              <Button
                onClick={handleClose}
                color="error"
                variant="contained"
                sx={{
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  fontWeight: 600,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  "&:hover": {
                    boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
                  },
                }}
              >
                View Plans
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </ThemeProvider>
    );
  };

  export default DashboardPage;